import { Injectable, Logger } from '@nestjs/common';
import { DataSource } from 'typeorm';

@Injectable()
export class MysqlService {
  private readonly logger = new Logger(MysqlService.name);

  constructor(private dataSource: DataSource) {}

  async testConnection() {
    try {
      await this.dataSource.query('SELECT 1 + 1 AS result');
      this.logger.log('Database connected successfully!');
    } catch (error) {
      this.logger.error('Database connection failed', error);
    }
  }
}